import Phaser from 'phaser';
import { gameSettings } from '@/config/gameSettings';
import { BootScene } from '@/scenes/BootScene';
import { GameplayScene } from '@/scenes/GameplayScene';
import { PreloadScene } from '@/scenes/PreloadScene';

export function createGame(parent: HTMLElement) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: gameSettings.backgroundColor,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: gameSettings.designWidth,
      height: gameSettings.designHeight,
    },
    render: {
      antialias: true,
      pixelArt: false,
      roundPixels: false,
    },
    physics: {
      default: 'arcade',
      arcade: {
        debug: false,
      },
    },
    input: {
      activePointers: gameSettings.maxPointers,
      touch: {
        capture: true,
      },
    },
    dom: {
      createContainer: true,
    },
    scene: [BootScene, PreloadScene, GameplayScene],
  });
}
